<template>
    <div class="event_redeem">
        <div v-show="isRedeemLoading" class="loading-cover">
            <div class="lds-spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
        <div class="card" v-if="event !== null">

            <div class="redeem-image">

            <div v-if="!startRedeem">
                <mdb-view>
                    <img :src="event.detail[0].image" :alt="event.detail[0].name">
                    <mdb-mask overlay="stylish-strong" flex-center text="尚未開始" />
                </mdb-view>
            </div>

            <div v-else-if="endRedeem">
                <mdb-view>
                    <img :src="event.detail[0].image" :alt="event.detail[0].name">
                    <mdb-mask overlay="stylish-strong" flex-center text="已結束" />
                </mdb-view>
            </div>

            <div v-else-if="event.limitation > 1 && event.limitation <= totalCodeCount">
                <mdb-view>
                    <img :src="event.detail[0].image" :alt="event.detail[0].name">
                    <mdb-mask overlay="stylish-strong" flex-center text="已達兌換上限" />
                </mdb-view>
            </div>

            <div v-else-if="!event.infinity_codes && event.codes_balance === 0">
                <mdb-view>
                    <img :src="event.detail[0].image" :alt="event.detail[0].name">
                    <mdb-mask overlay="stylish-strong" flex-center text="兌換完畢" />
                </mdb-view>
            </div>

            <div v-else>
                <img :src="event.detail[0].image" :alt="event.detail[0].name" />
            </div>

            </div>

            <div class="redeem-title-block">
                <div class="redeem-title">
                    <p class="event_title">{{ event.detail[0].name }}</p>

                    <div class="blue_line"></div>

                    <div class="big-points">
                        <img
                         src="@/assets/img/png/ic-kkpoints.png"
                         alt="kkpoints coin">
                        <p>{{ event.points }} 點</p>
                    </div>
                </div>

            </div>

            <div class="redeem-body">

            <div class="description_block"
              v-if="!redeemResult && (0 === event.limitation || event.limitation > totalCodeCount)">
                <p class="sub-title">活動期間：</p>
                <p>
                    {{ event.start_at | moment("YYYY") }}&nbsp;年
                    {{ event.start_at | moment("MM") }}&nbsp;月
                    {{ event.start_at | moment("DD") }}&nbsp;日
                    起至&nbsp;
                    {{ event.end_at | moment("YYYY") }}&nbsp;年
                    {{ event.end_at | moment("MM") }}&nbsp;月
                    {{ event.end_at | moment("DD") }}&nbsp;日
                </p>
            </div>

            <div class="description_block"
              v-if="!redeemResult && !event.infinity_codes && (0 === event.limitation || event.limitation > totalCodeCount)">
                <p class="sub-title">剩餘數量：</p>
                <p>{{ event.codes_balance }} 組</p>
            </div>

            <div class="description_block" v-if="redeemResult && !redeeming">
                <p class="sub-title">你的序號：</p>
                <div class="code_block">
                    {{ redeemResult.code }}
                    <font-awesome-icon class="copy_btn"
                      :icon="['far', 'copy']"
                      v-clipboard="redeemResult.code"
                      v-clipboard:success="copySuccessAlert"
                      v-clipboard:error="copyErrorAlert"
                    />
                </div>
            </div>

            <div class="description_block" v-if="myCodes.length > 0">
            <p class="sub-title">已兌換序號：</p>
            <template v-for="myCode in myCodes">
                <div class="code_block" v-bind:key="myCode.code">
                    {{ myCode }}
                    <font-awesome-icon class="copy_btn"
                      :icon="['far', 'copy']"
                      v-clipboard="myCode"
                      v-clipboard:success="copySuccessAlert"
                      v-clipboard:error="copyErrorAlert"
                    />
                </div>
            </template>
            </div>

            <div class="description_block" v-if="totalCodeCount > 0">
                <p class="sub-title">使用方式：</p>
                <p v-html="event.detail[0].redeem_description"></p>
            </div>

            <div class="redeem-btn-block">

            <div>
            <button
              v-if="!startRedeem"
              class="disabled_btn">
                尚未開始
            </button>
            <button
              v-else-if="endRedeem"
              class="disabled_btn">
                活動已結束
            </button>
            <button
              v-else-if="event.limitation > 1 && event.limitation <= totalCodeCount"
              class="disabled_btn">
                已達兌換上限
            </button>
            <button
              v-else-if="!event.infinity_codes && event.codes_balance === 0"
              class="disabled_btn">
                兌換完畢
            </button>
            <button
              v-else-if="redeeming"
              class="disabled_btn">
                兌換中.. <mdb-spinner />
            </button>
            <button
              v-else-if="(event.limitation === 1 && totalCodeCount === 0)
                || event.limitation === 0
                || (event.limitation > 1 && event.limitation > totalCodeCount)"
              class="redeem_btn"
              id="redeem_btn"
              @click="check()">
                <span>立即兌換</span>
            </button>
            </div>

            <div>
                <button class="back_btn" @click="backEventPage()">
                    查看其他活動
                </button>
            </div>

            </div>

            </div>

            <div class="redeem-footer">
            <div class="description_block">
                <p class="sub-title">注意事項：</p>
                <template
                  v-for="(description, index) in event.detail[0].remind_description_raw">
                    <p v-html="description"
                      v-if="index < 2 && !more_remind_description"
                      v-bind:key="index">
                    </p>
                    <p class="short_description"
                      v-html="description.substring(0, 5)+'.....'"
                      v-bind:key="index"
                      v-if="index == 2 && !more_remind_description">
                    </p>
                    <p class="see_more"
                      @click="more()"
                      v-bind:key="index"
                      v-if="index == 2 && !more_remind_description">
                        展開更多
                        <font-awesome-icon
                          :icon="['fas', 'angle-double-right']"
                        />
                    </p>
                </template>
                <p v-html="event.detail[0].remind_description" v-if="more_remind_description"></p>
            </div>

            </div>
        </div>
        <div v-show="isLoading" class="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex';
import CryptoJS from 'crypto-js';
import { mdbView, mdbMask } from 'mdbvue';
import envConfig from '../../env/env.config';

require('mdbvue/lib/css/mdb.min.css');

export default {
    name: 'event_redeem',
    components: {
        mdbView,
        mdbMask,
    },
    data() {
        return {
            event: null,
            now: this.moment((new Date()).getTime()).format('X'),
            decryptedData: null,
            csrfToken: null,
            isLoading: true,
            isRedeemLoading: false,
            startRedeem: false,
            endRedeem: false,
            myCodes: [],
            totalCodeCount: 0,
            redeemRunout: false,
            redeemResult: null,
            redeeming: false,
            check_message: null,
            more_remind_description: false,
            imageUrl: null,
        };
    },
    created() {
        this.accessToken = document.getElementById('access_token').content;

        this.getEvent();

        if (this.isLogin) {
            this.csrfToken = document.getElementById('csrf_token').content;
            const AES_KEY = this.csrfToken.slice(0, 16);
            const AES_IV = this.csrfToken.slice(16, 32);
            this.axios
                .get('/api/user', {
                    headers: {
                        'X-CSRF-TOKEN': this.csrfToken,
                    },
                })
                .then((response) => {
                    const decrypted = CryptoJS.AES.decrypt(
                        response.data,
                        CryptoJS.enc.Utf8.parse(AES_KEY),
                        { iv: CryptoJS.enc.Utf8.parse(AES_IV) },
                    );
                    this.decryptedData = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));

                    this.getMyKKPoints();
                    this.getMyCodes(true);
                })
                .catch((error) => {
                    if (error.response
                    && (error.response.status === 401
                        || error.response.status === 403)) {
                        this.$swal('登入異常', '請稍後重新登入', 'warning').then(() => window.location.reload());
                    } else if (error.response && error.response.status === 419) {
                        this.$swal('網頁逾時', '請重新整理頁面', 'warning').then(() => window.location.reload());
                    } else {
                        this.$swal('系統異常', '請重新整理後再試', 'error');
                    }
                });
        }
    },
    mounted() {
        const that = this;
        this.timer = setInterval(() => {
            that.now = this.moment((new Date()).getTime()).format('X');
        }, 1000);
    },
    beforeRouteLeave(to, from, next) {
        next();
    },
    beforeDestory() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    },
    methods: {
        getEvent() {
            this.isLoading = true;
            this.axios
                .get(`${envConfig.kkpointsApiBaseURL}/v1/events/${this.$route.params.event_id}`, {
                    headers: {
                        Authorization: this.accessToken,
                    },
                })
                .then((res) => {
                    this.event = res.data;
                    this.event.detail[0].remind_description_raw = res.data.detail[0].remind_description.split('<br />');
                    this.imageUrl = 'url("{event.detail[0].image}");';

                    if (res.data.detail[0].event_url !==  window.location.href) {
                        window.location = res.data.detail[0].event_url;
                    }

                    if (this.moment().unix() >= this.event.start_at) {
                        this.startRedeem = true;
                    }
                    if (this.moment().unix() >= this.event.end_at) {
                        this.endRedeem = true;
                    }
                })
                .catch((error) => {
                    if (error.response
                      && (error.response.status === 401
                      || error.response.status === 403)) {
                        this.$swal('登入異常', '請稍後重新登入', 'warning');
                    } else {
                        this.$swal('系統異常', '請重新整理後再試', 'error');
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        getMyCodes(countTotal) {
            this.isLoading = true;
            this.axios
                .get(`${envConfig.kkpointsApiBaseURL}/v2/events/${this.$route.params.event_id}/user-codes`, {
                    headers: {
                        Authorization: this.accessToken,
                    },
                    params: {
                        kkid_sub: this.decryptedData.sub,
                    },
                })
                .then((res) => {
                    if (res.data.data.length > 0) {
                        this.myCodes = Object.values(res.data.data).map(item => item.code);
                        if (countTotal) {
                            this.totalCodeCount += this.myCodes.length;
                        }
                    }
                })
                .catch((error) => {
                    if (error.response
                      && (error.response.status === 401
                      || error.response.status === 403)) {
                        this.$swal('登入異常', '請稍後重新登入', 'warning');
                    } else {
                        this.$swal('系統異常', '請重新整理後再試', 'error');
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        getMyKKPoints() {
            this.isLoading = true;
            this.axios
                .get(`${envConfig.kkpointsQueryApiBaseURL}/v2/my-kkpoints`, {
                    headers: {
                        Authorization: `Basic ${this.decryptedData.token}`,
                    },
                })
                .then((myKKpoints) => {
                    this.userPoints = myKKpoints.data.total_qty;
                })
                .catch((error) => {
                    if (error.response
                      && (error.response.status === 401
                      || error.response.status === 403)) {
                        this.$swal('登入異常', '請稍後重新登入', 'warning').then(() => window.location.reload());
                    } else {
                        this.$swal('系統異常', '請重新整理後再試', 'error');
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        backEventPage() {
            window.location.replace(`${window.location.protocol}//${window.location.host}/event`);
        },
        copySuccessAlert() {
            this.$swal('已複製到剪貼簿');
        },
        copyErrorAlert() {
            this.$swal('複製失敗，請手動複製。');
        },
        more() {
            this.more_remind_description = true;
        },
        getRedeemMessageByCode(code) {
            switch (code) {
            case '100001':
                this.check_message = '活動已到期';
                break;
            case '100002':
                this.check_message = '活動尚未公開';
                break;
            case '100003':
                this.check_message = '已達活動參加次數上限';
                break;
            case '100004':
                this.check_message = '此活動序號被兌換光了';
                break;
            case '200000':
                this.check_message = '您的點數不足';
                break;
            case '300000':
                this.check_message = '您的會員身份資格不符';
                break;
            case '400000':
                this.check_message = '扣點失敗，請確認點數是否足夠';
                break;
            default:
                this.check_message = '系統異常，請稍候在試';
            }
        },
        check() {
            this.isRedeemLoading = true;
            this.$swal({
                title: '確認兌換？',
                text: '點數一經兌換就無法退還囉！',
                buttons: {
                    confirm: {
                        text: '立即兌換',
                        value: true,
                        visible: true,
                        className: 'swal_redeem',
                        closeModal: true,
                    },
                    cancel: {
                        text: '取消',
                        value: false,
                        visible: true,
                        className: 'swal_cancel',
                        closeModal: true,
                    },
                },
            }).then((willRedeem) => {
                if (willRedeem) {
                    if (!this.isLogin) {
                        document.getElementById('login-form').submit();
                    }

                    this.redeeming = true;

                    this.getMyCodes(false);

                    this.axios
                        .get(`${envConfig.kkpointsApiBaseURL}/v2/events/${this.$route.params.event_id}/check`, {
                            headers: {
                                Authorization: this.accessToken,
                            },
                            params: {
                                kkid_sub: this.decryptedData.sub,
                            },
                        })
                        .then((res) => {
                            if (res.data.status.code !== '000000') {
                                this.getRedeemMessageByCode(res.data.status.code);

                                this.$swal({
                                    title: '兌換失敗',
                                    text: this.check_message,
                                    icon: 'warning',
                                    buttons: {
                                        other: {
                                            text: '查看其他活動',
                                            value: true,
                                            visible: true,
                                            closeModal: true,
                                        },
                                    },
                                }).then((goEvents) => {
                                    if (goEvents) {
                                        this.backEventPage();
                                    } else {
                                        window.location.reload();
                                    }
                                });
                            } else {
                                // 在此處做兌換
                                this.csrfToken = document.getElementById('csrf_token').content;
                                this.axios
                                    .post(`/api${window.location.pathname}/redeem`, [], {
                                        headers: {
                                            Authorization: `Basic ${this.decryptedData.token}`,
                                        },
                                    })
                                    .then((redeemRes) => {
                                        if (redeemRes.data.status.code !== '000000') {
                                            this.getRedeemMessageByCode(redeemRes.data.status.code);

                                            this.$swal({
                                                title: '兌換失敗',
                                                text: this.check_message,
                                                icon: 'warning',
                                                buttons: {
                                                    other: {
                                                        text: '查看其他活動',
                                                        value: true,
                                                        visible: true,
                                                        closeModal: true,
                                                    },
                                                },
                                            }).then((goEvents) => {
                                                if (goEvents) {
                                                    this.backEventPage();
                                                } else {
                                                    window.location.reload();
                                                }
                                            });
                                        } else {
                                            this.redeemResult = redeemRes.data.data;
                                            this.totalCodeCount += 1;

                                            this.getEvent();
                                        }
                                    })
                                    .catch((error) => {
                                        if (error.response
                                          && (error.response.status === 401
                                          || error.response.status === 403)) {
                                            this.$swal('登入異常', '請稍後重新登入', 'warning')
                                                .then(() => window.location.reload());
                                        } else if (error.response
                                          && error.response.status === 419) {
                                            this.$swal('網頁逾時', '請重新整理頁面', 'warning')
                                                .then(() => window.location.reload());
                                        } else if (error.response
                                            && error.response.status === 429) {
                                            this.$swal('偵測到異常行為', '同一帳號請勿使用多個視窗操作', 'warning')
                                                .then(() => window.location.reload());
                                        } else {
                                            this.$swal('系統異常', '請重新整理後再試', 'error');
                                        }
                                    })
                                    .finally(() => {
                                        this.redeeming = false;
                                    });
                            }
                        })
                        .catch((error) => {
                            if (error.response
                              && (error.response.status === 401
                              || error.response.status === 403)) {
                                this.$swal('登入異常', '請稍後重新登入', 'warning');
                            } else {
                                this.$swal('系統異常', '請重新整理後再試', 'error');
                            }
                        })
                        .finally(() => {
                            this.isRedeemLoading = false;
                        });
                } else {
                  this.isRedeemLoading = false;
                }
            });
        },
    },
    computed: {
        ...mapState([
            'isLogin',
        ]),
    },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "~@/scss/_mixins";
.event_redeem {
    padding-bottom: 60px;
    padding-top: 20px;
    .loading-cover {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: #cccccc87;
        z-index: 1;
        .lds-spinner {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
    .back_link {
        position:absolute;
        bottom: 5px;
        right: 10px;
        font-size: 16px;
        font-weight: 400;
        color: black !important;
        display:block;
        width: 300px;
        text-align: right;
    }
    .sub-title {
        font-weight: 500;
        margin-bottom: 5px;
    }
    .redeem-balance {
        background-color: black;
        color: #fff;
        text-align: center;
        padding: 20px 0;
        font-weight: 400;
        position: relative;
    }

    .redeem-image {
        width: 100%;
        margin-bottom: -10px;
        img {
            width: 100%;
        }
    }
    .redeem-title-block {
        position: relative;
    }
    .redeem-title {
        padding: 20px 30px 0;
        text-align: center;

        .event_title {
            margin: 10px auto 30px !important;
            font-size: 20px;
            font-weight: 300;
            letter-spacing: 2.5px;
            margin: 0 15px;
            text-align: center;
            color: #00aed8;
        }
        .big-points {
            text-align: center;
            font-weight: 500;
            width: 110px;
            top: -30px;
            padding: 5px;
            background-color: #fff;
            color: #00aed8;
            box-sizing: border-box;
            border-radius: 16px;
            margin: 0 auto;
            position: relative;
            img {
                position: absolute;
                left: 14px;
                top: 6px;
                height: 20px;
                width: 20px;
            }
            p {
                margin-left: 25px;
            }
        }

        .big-balance {
            position:absolute;
            bottom: 10px;
            right: 15px;
            text-align: center;
            font-weight: 500;
            width: 120px;
            padding: 3px 15px;
            background-color: red;
            color: #fff;
            box-sizing: border-box;
            border-radius: 16px;
        }
    }
    .redeem-body {
        padding: 0 25px 15px;
        text-align: left;
        position: relative;
    }
    .redeem-footer {
        background-color:rgba(0,0,0,0.03);
        padding: 20px 25px;
        border-top: 1px solid rgba(0,0,0,0.125);
    }
    .redeem-btn-block {
        text-align: center;
        margin-top: 30px;
    }
    .card {
        background-color: #fff;
        width: 375px;
        margin: 20px auto;
        font-weight: 300;
        @include for-sm-mobile {
            width: 320px;
        }
        @include for-xs-mobile {
            width: 275px;
        }
        img {
            width: 100%;
        }
        a {
            color: #00aed8;
        }
        button.back_btn {
            text-align: center;
            color: #00aed8;
            font-size: 16px;
            font-weight: 300;
            width: 150px;
            cursor: pointer;
            display: inline-block;
            background-color: transparent;
            border: none;
            padding: 0;
            &:focus {
              outline: none;
            }
        }
        button.redeem_btn {
            text-align: center;
            color: #ffffff;
            font-size: 16px;
            font-weight: 300;
            padding: 5px 30px;
            border-radius: 16px;
            border: none;
            background-color: #00aed8;
            cursor: pointer;
            display: inline-block;
            margin: 0px auto 10px;
            &:focus {
              outline: none;
            }
            &:hover {
                box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.25);
            }
            &:disabled {
                border-color: #cdcdcd;
                background-color: #cdcdcd;
                cursor: none;
            }
        }
        button.disabled_btn {
            text-align: center;
            color: #ffffff;
            font-size: 16px;
            border-radius: 16px;
            padding: 5px 30px;
            border-radius: 16px;
            border: none;
            background-color: rgba(0,0,0,0.2);
            display: inline-block;
            margin: 0px auto 10px;
            &:focus {
              outline: none;
            }
        }
        .blue_line {
            border-bottom: 1px solid #00aed8;
            width: 100%;
            margin: 15px auto;
        }
        .blue_word {
            color: #00aed8;
        }
        .description_block {
            text-align: left;
            margin-bottom: 30px;
        }
        .description_block p {
            text-align: left;
            font-size: 14px;
        }
        .short_description {
            width: auto;
            display:inline-block;
        }
        .see_more {
            color: #00aed8;
            cursor: pointer;
            display:inline-block;
            font-weight: 400;

        }
        .code_block {
            background-color: rgba(0,0,0,0.05);
            height: 40px;
            width: 100%;
            text-align: left;
            padding: 10px;
            margin-bottom: 10px;
        }
        .copy_btn {
            float: right;
            font-size: 20px;
        }
    }
}
</style>
<style>
.white-text {
    font-size: 36px !important;
    font-weight: 1000 !important;
}
.swal-title {
    color:#00aed8;
}
.swal-text {
    color: rgba(0,0,0,.75);
    font-size: 20px;
    font-weight: 500;
}
.swal-button-container {
    display: block;
    text-align: center;
}
.swal_redeem {
    text-align: center;
    border: none;
    cursor: pointer;
    padding: 5px 50px;
    background-color: #00aed8;
    color: #ffffff;
    border-radius: 20px;
    font-size: 20px;
    font-weight: 400;
}
.swal_redeem:hover {
    background-color: #00aed8 !important;
    color:  rgba(0,0,0,0.3) !important;
}
.swal_cancel {
    text-align: center;
    cursor: pointer;
    color: rgba(0,0,0,0.6);
    background-color: transparent;
    border: none;
    padding: 0;
    font-weight: 400;
    font-size: 16px;
}
.swal_cancel:hover {
    background-color: transparent !important;
}
.swal_cancel:focus {
    outline: none;
    box-shadow: none;
}
</style>
